import { Routing } from "web_myplann/Infrastructure/Routing/Routing";

export const isFinancesWizardPath = (pathname: string) =>
	[
		Routing.Finances.Income.path(),
		Routing.Finances.Expenses.path(),
		Routing.Finances.Overview.path(),
	].includes(pathname);
